import { useState, useMemo } from "react";

const AddProductAtGroup = ({ isOpen, onClose, onAddToGroup, preloadedProducts = [] }) => {
  const [selectedProductIds, setSelectedProductIds] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const placeholderImage = "https://via.placeholder.com/50?text=IMG";

  // Filtra los productos precargados según el término de búsqueda
  const filteredProducts = useMemo(() => {
    if (!searchTerm.trim()) return preloadedProducts;
    const lowerTerm = searchTerm.toLowerCase();
    return preloadedProducts.filter((product) => {
      const name = String(product.nombre || "").toLowerCase();
      const parte = String(product.numeroDeParteProveedor || "").toLowerCase();
      const desc = String(product.descripcion || "").toLowerCase();
      return (
        name.includes(lowerTerm) ||
        parte.includes(lowerTerm) ||
        desc.includes(lowerTerm)
      );
    });
  }, [searchTerm, preloadedProducts]);

  const handleToggleProduct = (productId) => {
    setSelectedProductIds((prev) =>
      prev.includes(productId)
        ? prev.filter((id) => id !== productId)
        : [...prev, productId]
    );
  };

  const handleConfirm = () => {
    onAddToGroup(selectedProductIds);
    setSelectedProductIds([]);
    onClose();
  };

  if (!isOpen) return null;

  return (
    <div style={styles.overlay}>
      <div style={styles.modal}>
        {/* Botón de cierre (X) */}
        <button onClick={onClose} style={styles.closeButton}>
          <i className="bi bi-x-lg"></i>
        </button>

        {/* Título */}
        <h2 style={styles.title}>Selecciona Productos</h2>

        {/* Buscador */}
        <div style={styles.searchContainer}>
          <i className="bi bi-search" style={styles.searchIcon}></i>
          <input
            type="text"
            placeholder="Buscar producto..."
            style={styles.searchInput}
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
          />
        </div>

        {/* Contenido scrollable */}
        <div style={styles.content}>
          {filteredProducts.length === 0 ? (
            <p style={styles.noProducts}>No hay productos disponibles.</p>
          ) : (
            filteredProducts.map((product) => {
              const isChecked = selectedProductIds.includes(product.id);
              return (
                <div key={product.id} style={styles.productItem}>
                  <input
                    type="checkbox"
                    checked={isChecked}
                    onChange={() => handleToggleProduct(product.id)}
                    className="checkbox-select-all check"
                  />
                  <img
                    src={product.imagen || placeholderImage}
                    alt="Producto"
                    style={styles.productImage}
                  />
                  <div style={styles.textContainer}>
                    <div style={styles.productName}>
                      {product.nombre || "Sin nombre"}
                    </div>
                    <div style={styles.productDescription}>
                      {product.numeroDeParteProveedor ||
                        product.numeroDeParte ||
                        product.descripcion ||
                        "Sin detalles"}
                    </div>
                  </div>
                </div>
              );
            })
          )}
        </div>

        {/* Footer: solo se muestra si hay productos seleccionados */}
        {selectedProductIds.length > 0 && (
          <div style={styles.footer}>
            <div style={styles.buttonsContainer}>
              <button onClick={onClose} className="sp-cancel-btn">
                Cancelar
              </button>
              <button onClick={handleConfirm} className="sp-add-btn">
                Agregar
              </button>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

const styles = {
  overlay: {
    position: "fixed",
    top: 0,
    left: 0,
    width: "100vw",
    height: "100vh",
    backgroundColor: "rgba(0, 0, 0, 0.6)",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    zIndex: 9999,
  },
  modal: {
    position: "relative",
    backgroundColor: "#fff",
    display: "flex",
    flexDirection: "column",
    padding: "30px",
    borderRadius: "8px",
    width: "90%",
    maxWidth: "600px",
    maxHeight: "80vh",
    boxShadow: "0 5px 15px rgba(0,0,0,0.3)",
    msOverflowStyle: "none",
    scrollbarWidth: "none",
  },
  closeButton: {
    position: "absolute",
    top: "10px",
    right: "15px",
    background: "none",
    border: "none",
    fontSize: "1.2em",
    cursor: "pointer",
    color: "#666",
  },
  title: {
    margin: "0 0 20px",
    textAlign: "left",
    fontSize: "1.3rem",
    fontWeight: "bold",
    borderBottom: "1px solid #eaeaea",
    paddingBottom: "10px",
  },
  searchContainer: {
    display: "flex",
    alignItems: "center",
    borderRadius: "6px",
    border: "1px solid #ccc",
    margin: "10px 0 0",
    padding: "6px 10px",
  },
  searchIcon: {
    fontSize: "1rem",
    color: "#666",
    marginRight: "8px",
  },
  searchInput: {
    border: "none",
    outline: "none",
    flex: 1,
    background: "transparent",
    fontSize: "0.95rem",
    color: "#333",
  },
  content: {
    flex: 1,
    overflowY: "auto",
    marginTop: "20px",
    marginBottom: "20px",
  },
  noProducts: {
    textAlign: "center",
    color: "#888",
  },
  productItem: {
    display: "flex",
    alignItems: "center",
    backgroundColor: "#f9f9f9",
    borderRadius: "8px",
    padding: "10px",
    marginBottom: "10px",
    position: "relative",
    boxShadow: "0 1px 2px rgba(0,0,0,0.1)",
  },
  productImage: {
    width: "50px",
    height: "50px",
    borderRadius: "50%",
    objectFit: "cover",
    marginRight: "15px",
    marginLeft: "10px",
  },
  textContainer: {
    display: "flex",
    flexDirection: "column",
    flex: 1,
  },
  productName: {
    fontWeight: "bold",
    fontSize: "0.95rem",
    marginBottom: "5px",
    color: "#333",
  },
  productDescription: {
    fontSize: "0.85rem",
    color: "#777",
  },
  footer: {
    borderTop: "1px solid #eaeaea",
    paddingTop: "15px",
  },
  buttonsContainer: {
    display: "flex",
    justifyContent: "flex-end",
    gap: "10px",
  },
};

export default AddProductAtGroup;
